<template>

    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="30%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">Confirm {{ entityType }} deletion</span>

                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text class="modal-height" style="text-align: left">

                        <span class="body-2">Deleting a {{ entityType }} will permanently remove it from the database.</span>

                    </v-card-text>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="confirm_pool_deletion_button" class="text-none" color="red" small dark
                               @click="onDeleteMacPool">Yes, delete
                            {{entityType}}
                        </v-btn>
                        <v-btn id="cancel_pool_deletion_button" class="text-none" small @click="close">No, keep {{
                            entityType }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>


</template>

<script>

    import {EventBus} from "../../../eventbus";
    import poolinterface from "../../../interfaces/poolinterface";
    import errormessagemanager from "../../../managers/errormessagemanager";

    export default {
        name: 'ConfirmPoolDeletionModal',

        data: () => ({
            entityType: "MAC-pool",
            error: false,
            errorMessage: null,
        }),

        props: {
            value: Boolean,

            macPool: {
                poolId: Number,
                oui: String,
                name: String,
                description: String,
                startMac: String,
                endMac: String,
                nextMac: String,
                capacity: Number,
                available: Number,
                availableInPercent: Number,
                isActive: Boolean,
                macsPerReq: Number,
                macsPerUserDay: Number,
                rowVersion: Array
            },
        },

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            async onDeleteMacPool() {
                this.clearAlert();
                let response = null;

                await poolinterface.deleteMacPool(this.macPool, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    await EventBus.$emit('macPoolDeletionConfirmed');

                    this.onShow = false;
                    this.macPool = null;

                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },

            async close() {
                let event = "macPoolDeletionClosed";

                await EventBus.$emit(event);
                this.onShow = false;
                this.macPool = null;
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = "";
            }
        }
    }
</script>

<style>
    .modal-height {
        min-height: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/macpools/modals/ConfirmPoolDeletionModal.vue